// TODO: Remove this when we support proper column sorting. This is a dirty way to sort until that is supported.

import _ from 'lodash';

import {TableColumn} from '../../../../../../../../../src/components/common/table/tableColumn';
import {compareName} from '../../../../../../../../../srcCommon/helpers/localeHelpers';
import {AccountsTableColumnsEnum} from './accountsTableConfig';

// The only column that is guaranteed to be there currently is "description" so this is pretty nastily hardcoded.
export function contactsManagerAccountsSortColumns(
  columns: ReadonlyArray<TableColumn<AccountsTableColumnsEnum>>,
) {
  return _([...columns])
    .sort((a, b) => {
      const aName =
        a.type === AccountsTableColumnsEnum.DESCRIPTION ? 'description' : String(a.title).toLowerCase();
      const bName =
        b.type === AccountsTableColumnsEnum.DESCRIPTION ? 'description' : String(b.title).toLowerCase();
      return compareName(aName, bName);
    })
    .value();
}
